const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader-spinner"></div>
    </div>
  );
};

export default Loader;